import { SquareNewWindowIcon, Typography } from "@codat/orchard-ui";
import React from "react";

import Button from "components/Button";
import styles from "pages/ProductPages/ProductPagesHeader/ProductPagesHeader.module.css";

interface ProductPagesHeaderProps {
  productName: string;
}

const ProductPagesHeader: React.FC<ProductPagesHeaderProps> = ({
  productName,
}) => {
  return (
    <div className={styles.headerContainer}>
      <Typography
        as="h1"
        variant="heading_xxl"
        data-testid="product-pages-header"
      >
        {productName} API
      </Typography>
      <Button
        href={`https://docs.codat.io/data-model/${productName.toLowerCase()}`}
        target="_blank"
        variant="secondary"
        color="interface"
        data-testid="documentation-button"
        buttonName="Documentation"
        eventProperties={{
          productName,
        }}
      >
        {`${productName} API docs`}
        <SquareNewWindowIcon className={styles.newWindowIcon} />
      </Button>
    </div>
  );
};

export default ProductPagesHeader;
